export class Inclusion_Exclusiondata {

    inclusionList: Array<any>; exclusionList: Array<any> = [
        { "title": String }]

}